import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import theme from "src/theme/light";

interface ModalRestaurarSolucaoProps {
  isOpened: boolean;
  closeModal: () => void;
  finame: boolean;
  onEditarEstruturas: () => void;
  onRemoverEstruturas: () => void;
}
const useStyles = makeStyles({
    tooltipPopper: {
      marginBottom: '-14px',
    },
    boxButton: {
      display: "flex",
      justifyContent: "end",
      gap: "10px"
    },
    editButton: {
      backgroundColor: theme.palette.warning.dark,
      color: theme.palette.getContrastText(theme.palette.warning.dark),
      '&:hover': {
        backgroundColor: theme.palette.warning.dark,
      }
    }
})

export const ModalRestaurarSolucao = ({ closeModal, isOpened, finame, onEditarEstruturas, onRemoverEstruturas }: ModalRestaurarSolucaoProps) => {
  const classes = useStyles();
  return (
    <Dialog open={isOpened}>
      <DialogTitle>
        <Box display='flex' alignItems='center'>
          <Box>Atenção</Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
            <Box>
              <Typography style={{fontWeight: "bold"}}>Importante!</Typography>
              <Typography style={{marginTop: "15px"}}>Após a restauração da solução, foi identificada uma inconsistência na configuração das estruturas em relação à necessidade do projeto. Para que você siga com a opção mais adequada, escolha uma das alternativas abaixo:</Typography>
            </Box>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Box className={classes.boxButton}>
          <FlatButton
            size="medium"
            variant={"contained"}
            disableElevation
            text="Editar estrutura"
            className={classes.editButton}
            onClick={()=>{
              onEditarEstruturas();
            }}
          />
            {finame ? (
              <Tooltip
                title="Projetos FINAME devem, obrigatoriamente, ter estrutura associada."
                arrow
                placement="top-start"
                classes={{ popper: classes.tooltipPopper }}>
                  <span>
                    <div style={{ pointerEvents: 'none', width: '100%' }}>
                      <FlatButton
                        color="primary"
                        variant="contained"
                        disableElevation
                        disabled={finame}
                        text="Seguir sem estrutura"
                        onClick={closeModal}
                      />
                    </div>
                  </span>
              </Tooltip>
            ) : (
                <FlatButton
                color="primary"
                variant="contained"
                disableElevation
                disabled={finame}
                text="Seguir sem estrutura"
                onClick={onRemoverEstruturas}
              />
            )
          }
        </Box>
      </DialogActions>
    </Dialog>
  )
}